export const navCopy = {
  skip_to_content: "Aller au contenu principal",
  nav_documentation: "Documentation",
  nav_documentation_short: "Docs",
  nav_download: "Télécharger",
  nav_community: "Communauté",
  nav_playground: "Playground",
  nav_playground_short: "Play",
  nav_handbook: "Guide",
  nav_tools: "Outils",
  nav_search_placeholder: "Rechercher",
  nav_search_aria: "Rechercher sur le site TypeScript",
  // let me know if you can't make this work in your lang:
  // TypeScript X.Y [stable][between?]Z.Y[beta/rc]
  nav_version_stable_prefix: "est maintenant disponible",
  nav_version_between: ", ",
  nav_version_beta_prefix: "est actuellement en bêta.",
  nav_version_rc_prefix: "est une version candidate, essayez-la.",
  nav_this_page_in_your_lang: "Cette page est disponible dans votre langue",
  nav_this_page_in_your_lang_open: "Ouvrir",
  nav_this_page_in_your_lang_no_more: "Ne plus montrer",
};
